import styled from 'styled-components';
import { typography } from '@clds/typography';

export const StyledMobileMenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${(props) => props.theme.spacing.xs} ${(props) => props.theme.spacing.xs} ${(props) => props.theme.spacing.xs}
    ${(props) => props.theme.spacing.md};
  ${typography.xs.highContrast};
`;
